import React from "react";
import { Box, Grid, Typography, CircularProgress, Button } from "@mui/material";
import DottedCard from "../DottedCard";
import WalletCard from "../WalletCard";
import useAuth from "../../hooks/useAuth";
import AccountCard from "../AccountCard";

const ModalTab = ({ title, handleClick, onPageChange, loading }) => {
  const { queryUserDetails } = useAuth();
  const { manageTransaction, manageAccount } = queryUserDetails;
  
  const currentPage = manageTransaction?.pageable?.pageNumber !== undefined ? manageTransaction.pageable.pageNumber : manageTransaction?.number || 0;
  const totalPages = manageTransaction?.totalPages || 0;
  const isFirst = manageTransaction?.first !== undefined ? manageTransaction.first : (currentPage === 0);
  const isLast = manageTransaction?.last !== undefined ? manageTransaction.last : (currentPage >= totalPages - 1);
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      justifyContent="center"
    >
      <Typography variant="h4" m={3} textAlign="center" gutterBottom>
        {title}
      </Typography>
      <Box maxHeight={500} sx={{ overflowY: "scroll" }}>
        <Grid
          container
          padding={2.5}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          {title === "Accounts" ? (
            (manageAccount?.accounts || []).map((wallet, index) => {
              const mappedWallet = {
                accountNo: wallet.accountNumber,
                acct_name: wallet.accountName,
                clr_bal_amt: wallet.availableBalance,
                acct_crncy_code: "₦",
                acct_opn_date: wallet.accountStatus,
                walletDefault: wallet.primaryAccount
              };
              return <WalletCard key={index} wallet={mappedWallet} />;
            })
          ) : title === "Banks" ? (
            <AccountCard account={manageAccount} />
          ) : title === "Transactions" ? (
            loading ? (
              <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" minHeight={150}>
                <CircularProgress color="secondary" />
              </Grid>
            ) : (manageTransaction?.content || []).length === 0 ? (
              <Grid item xs={12}>
                <Typography variant="body1" textAlign="center" color="grey" my={2}>
                  No transactions found for this user.
                </Typography>
              </Grid>
            ) : (
              (manageTransaction?.content || []).map((tx, index) => (
                <Grid item xs={12} key={index}>
                  <Box
                    sx={{
                      p: 2,
                      mb: 1,
                      border: "1px solid #7c7c7c",
                      borderRadius: "5px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <Box>
                      <Typography variant="h6" fontWeight="bold">
                        {tx.narration || tx.description || tx.transactionType || "Transaction"}
                      </Typography>
                      <Typography variant="body2" color="grey">
                        Ref: {tx.tranRef || tx.paymentReference || tx.reference || "N/A"}
                      </Typography>
                      <Typography variant="caption" color="grey">
                        {tx.transactionDate || tx.createdAt || "N/A"}
                      </Typography>
                    </Box>
                    <Box textAlign="right">
                      <Typography variant="h6" color="#4caf50" fontWeight="bold">
                        ₦{tx.amount !== undefined ? tx.amount : "0.00"}
                      </Typography>
                      <Typography variant="caption" color={tx.status === "SUCCESS" || tx.status === "APPROVED" ? "#4caf50" : "#f44336"}>
                        {tx.status || "COMPLETED"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))
            )
          ) : (
            <WalletCard />
          )}
          {title === "Transactions" && totalPages > 1 && !loading && (
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                mt={3}
                gap={2}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  disabled={isFirst}
                  onClick={() => onPageChange && onPageChange(currentPage - 1)}
                  size="small"
                >
                  Previous
                </Button>
                <Typography variant="body2">
                  Page {currentPage + 1} of {totalPages}
                </Typography>
                <Button
                  variant="outlined"
                  color="secondary"
                  disabled={isLast}
                  onClick={() => onPageChange && onPageChange(currentPage + 1)}
                  size="small"
                >
                  Next
                </Button>
              </Box>
            </Grid>
          )}
          {title !== "Transactions" && <DottedCard handleClick={handleClick} />}
        </Grid>
      </Box>
    </Box>
  );
};

export default ModalTab;
